import { render, staticRenderFns } from "./RelativeList.vue?vue&type=template&id=0f98e204"
import script from "./RelativeList.vue?vue&type=script&lang=js"
export * from "./RelativeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports